import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { REQUIRED_ROLES } from "../config/authConfig";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isAuthChecking, userRoles } = useAuth();

  // Wait for the initial auth check to complete before deciding to redirect.
  // Without this, Firefox throttles the History API due to the rapid
  // redirect loop caused by ProtectedRoute redirecting before auth resolves.
  if (isAuthChecking) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  // console.log("role access details:", {
  //   requiredRoles: REQUIRED_ROLES,
  //   userRoles,
  // });

  // block access if user does not have at least one required role
  if (!userRoles.some((role) => REQUIRED_ROLES.includes(role))) {
    return <h3>Access Denied: You do not have the required role.</h3>;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
